
//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';

//```import constants types
import {
    CREATE_DIAGNOSTIC_DEVICE_GET_DEVICE_REQUEST,
    CREATE_DIAGNOSTIC_DEVICE_SEARCH_DEVICE_MODEL_REQUEST,
    CREATE_DIAGNOSTIC_DEVICE_SEARCH_COMMANDS_REQUEST,
    CREATE_DIAGNOSTIC_DEVICE_REQUEST,
} from 'Redux/actionTypes';

import { endpoints } from 'Core/defaultValues';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import {
    createDiagnosticDeviceGetDeviceResult,
    createDiagnosticDeviceSearchDeviceModelResult,
    createDiagnosticDeviceSearchCommandsResult,
    createDiagnosticDeviceResult,
} from 'Redux/actions';


function* getDevice({ payload }) {
    try {
        const QUERY = `
            query searchUnits ($conditions: [UnitSearchInput], $sort: [UnitSortInput], $limit: Int, $offset: Int) {
                result: searchUnits (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        id
                        label
                        esn
                        imei
                        simCard {
                            iccId
                            msisdn
                            simProviderAccount {
                                id
                                name
                                simProviderId
                                simProvider {
                                    id
                                    name
                                }
                            }
                        }
                        deviceModel {
                            id
                            unitTypeId
                            unitType {
                                id
                                name
                                manufacturerId
                                manufacturer {
                                    id
                                    name
                                }
                                dbSchema
                                active
                            }
                            name
                            manufacturerId
                            manufacturer {
                                id
                                name
                            }
                        }
                    }
                    total 
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                conditions: {
                    fields: ["esn", "imei"],
                    terms: payload,
                    exact: true
                },
                limit: 100,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(createDiagnosticDeviceGetDeviceResult(data?.result))
        } else {
            yield put(createDiagnosticDeviceGetDeviceResult({ error: true }))
        }

    } catch (exc) {
        yield put(createDiagnosticDeviceGetDeviceResult({ error: true }))
        ExceptionManager(
            exc,
            "Modules/devices/.components/createDiagnosticDevice/redux/saga",
            "getDevice"
        )
    }
}

function* searchDeviceModelForId({ payload }) {
    try {

        let QUERY = `
            query searchUnits ($conditions: [UnitSearchInput], $sort: [UnitSortInput], $limit: Int, $offset: Int) {
                result: searchUnits (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        id
                        deviceModel {
                            id
                            unitTypeId
                            unitType {
                                id
                                name
                                manufacturerId
                                manufacturer {
                                    id
                                    name
                                }
                                dbSchema
                                active
                            }
                            name
                            manufacturerId
                            manufacturer {
                                id
                                name
                            }
                        }
                    }
                    total
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                conditions: {
                    fields: ["id"],
                    terms: payload,
                    exact: true
                },
                limit: 100,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(createDiagnosticDeviceSearchDeviceModelResult(data?.result))
        }

    } catch (exc) {
        yield put(createDiagnosticDeviceSearchDeviceModelResult({ error: exc }))
        ExceptionManager(
            exc,
            "Modules/devices/.components/createDiagnosticDevice/redux/saga",
            "searchDeviceModelForId"
        )
    }
}

function* searchCommands({ payload }) {
    try {
        let QUERY = `
            query searchCannedCommands ($conditions: [CannedCommandSearchInput], $sort: [CannedCommandSortInput], $limit: Int, $offset: Int) {
                result: searchCannedCommands (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        id
                        unitTypeId
                        unitType {
                            id
                            name
                            manufacturerId
                            manufacturer {
                                id
                                name
                            }
                            dbSchema
                            active
                        }
                        via
                        label
                        command
                        status
                        appliesToAllUnitTypes
                    }
                    total
                }
            }
        `;
        let data = yield call(
            clientQuery,
            QUERY,
            {
                conditions: [
                    {
                        fields: ["manufacturerId"],
                        terms: [payload.manufacturerId],
                        exact: true
                    },
                    {
                        fields: ["via"],
                        terms: [payload.via],
                        exact: true
                    }
                ],
                limit: 300,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            let realItems = [];
            const { items } = data.result;
            realItems = items.filter(x => x.unitTypeId === payload.unitTypeId || x.appliesToAllUnitTypes)
            yield put(createDiagnosticDeviceSearchCommandsResult(realItems))
        } else {
            yield put(createDiagnosticDeviceSearchCommandsResult([]))
        }
    } catch (exc) {
        yield put(createDiagnosticDeviceSearchCommandsResult([]))
        ExceptionManager(
            exc,
            "Modules/devices/.components/createDiagnosticDevice/redux/saga",
            "searchCommands"
        )
    }
}

function* createDiagnosticDevice({ payload }) {
    try {
        let QUERY = `
            mutation createDeviceDiagnostic ($unitIds: [Int]!) {
                DiagnosticResult: createDeviceDiagnostic (unitIds: $unitIds) {
                    stepFunctionId
                    transactionId
                    transactionType
                    processStartDate
                }
            }
        `;

        const data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );


        yield put(createDiagnosticDeviceResult(data))


    } catch (exc) {
        yield put(createDiagnosticDeviceResult({ error: exc }))
        ExceptionManager(
            exc,
            "Modules/devices/.components/createDiagnosticDevice/redux/saga",
            "createDiagnosticDevice"
        )
    }
}

function* watchMethods() {
    yield takeEvery(CREATE_DIAGNOSTIC_DEVICE_GET_DEVICE_REQUEST, getDevice);
    yield takeEvery(CREATE_DIAGNOSTIC_DEVICE_SEARCH_DEVICE_MODEL_REQUEST, searchDeviceModelForId);
    yield takeEvery(CREATE_DIAGNOSTIC_DEVICE_SEARCH_COMMANDS_REQUEST, searchCommands);
    yield takeEvery(CREATE_DIAGNOSTIC_DEVICE_REQUEST, createDiagnosticDevice);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}